import { Box } from '@material-ui/core';
import { TitlePage } from 'component/customize_style_component/styled_title';
import { useEffect, useRef, useState } from 'react';
import { useStyles } from './style';
// import posterOnBoarding from 'assets/img/poster_onboarding.png';
import onboardingLogo from 'assets/img/onboarding/onboarding-logo.png';
import { Swiper, SwiperSlide } from 'swiper/react';
import { ArrowForward } from '@material-ui/icons';
import Div100vh from 'react-div-100vh';
import './onboarding-slide.scss';
import {
    // INTRODUCING_VIDEO,
    STRINGS,
} from 'constants/index';
// import { trackEvent, TRACK_EVENT } from 'utils/analytics';
// import playIcon from 'assets/img/play-btn.png';
import utils from 'utils/utils';

export interface ICustomerOnboadingProps {
    handleFinishOnboardProcess: () => void;
    onViewChanged: (viewIndex: number) => void;
}

export default function CustomerOnboading({ onViewChanged, handleFinishOnboardProcess }: ICustomerOnboadingProps) {
    const classes = useStyles();
    const [activeItem, setActiveItem] = useState(0);
    const videoRef = useRef(null);
    // const [played, setVideoPlayStatus] = useState(false);
    const pagination = {
        clickable: true,
    };

    const renderFirstSlide = () => (
        <Box className={`${classes.firstProcessOnboardingContainer} ${classes.slideItem}}`}>
            <Box display={'flex'} flexDirection={'column'} alignItems={'center'} textAlign={'center'} maxWidth="322px">
                <img src={onboardingLogo} width={128} alt="logo" />
                <TitlePage size={32} color={'white'}>
                    Personalized Styling <br></br> For Every Occasion
                </TitlePage>
                <div style={{ marginTop: 20 }} className={classes.subSlideTitle}>
                    {STRINGS.EXPERT_STYLIST_ACCESS}
                </div>
                <div className={classes.subSlideTitle}>{STRINGS.HYPER_PERSONALIZED_LOOKS}</div>
                <div className={classes.subSlideTitle}>{STRINGS.PERSONAL_DIGITAL_WARDROBE}</div>
            </Box>
        </Box>
    );

    // const renderSecondSlide = () => (
    //     <Box className={`${classes.secondProcessOnboardingContainer} ${classes.slideItem}`}>
    //         <Box textAlign={'center'} maxWidth="322px">
    //             <img src={onboardingLogo} width={128} alt="logo" />
    //             <TitlePage size={32} color={'white'}>
    //                 Get Styled By <br /> Taffi Experts
    //             </TitlePage>
    //             {/* <TitlePage size={16} color={'white'}>
    //                 Starting from just AED 50
    //             </TitlePage> */}
    //         </Box>
    //     </Box>
    // );

    // const renderThirdSlide = () => (
    //     <Box className={`${classes.thirdProcessOnboardingContainer} ${classes.slideItem}`}>
    //         <video
    //             ref={videoRef}
    //             poster={posterOnBoarding}
    //             playsInline={true}
    //             style={{ width: 'auto', height: '100%' }}
    //             src={INTRODUCING_VIDEO}
    //             autoPlay={false}
    //             preload={'true'}
    //             onPlaying={() => setVideoPlayStatus(true)}
    //             onPause={() => setVideoPlayStatus(false)}
    //             controls
    //         />
    //         {!played ? (
    //             <img
    //                 className="video-player-play-icon"
    //                 alt="play-video"
    //                 onClick={() => {
    //                     (videoRef as any).current.play();
    //                     trackEvent(TRACK_EVENT.PLAY_INTRODUCING_VIDEO_ON_SIGNUP, {
    //                         userType: 'customer',
    //                     });
    //                 }}
    //                 src={playIcon}
    //                 width={100}
    //             />
    //         ) : null}
    //     </Box>
    // );

    const validateVideo = (activeIndex) => {
        if (activeIndex !== 2) {
            try {
                (videoRef as any).current.pause();
            } catch {}
        }
    };

    const renderContentOnboarding = () => {
        const dynamicStyles = utils.isAppInWidgetMode()
            ? {
                maxHeight: 'calc(100% - 95px)',
                marginTop: '30px',
            }
            : {
                maxHeight: 'calc(100% - 65px)',
            };
        return (
            <Box flex={1} display={'flex'} className="slide-wapper" style={{ ...dynamicStyles }}>
                <Swiper
                    pagination={pagination}
                    onSlideChange={(e) => {
                        validateVideo(e.activeIndex);
                        setActiveItem(e.activeIndex);
                    }}
                    style={{ width: '100%' }}
                >
                    <SwiperSlide>{renderFirstSlide()}</SwiperSlide>
                    {/* <SwiperSlide>{renderSecondSlide()}</SwiperSlide> */}
                    {/* <SwiperSlide>{renderThirdSlide()}</SwiperSlide> */}
                </Swiper>
            </Box>
        );
    };

    useEffect(() => {
        onViewChanged(activeItem + 1);
    }, [activeItem, onViewChanged]);

    const renderBottomActions = () => {
        return (
            <Box className={classes.action}>
                <button
                    className={classes.button}
                    style={{ marginLeft: 'auto', marginRight: 'auto' }}
                    onClick={handleFinishOnboardProcess}
                >
                    Get Started <ArrowForward width={18} style={{ marginLeft: 4 }} fontSize="medium" />
                </button>
            </Box>
        );
    };

    return (
        <Div100vh className={classes.wrapper}>
            <Box className={classes.content}>
                {renderContentOnboarding()}
                {renderBottomActions()}
            </Box>
        </Div100vh>
    );
}
